import type { TaskItem } from '~/types/context';

interface TaskUpdate {
  type: 'taskUpdate';
  tasks: TaskItem[];
}

/**
 * Latest plan state for a message. Prefers v6 message metadata (the server
 * merges each message-metadata part, so it is always current); falls back to
 * the LAST taskUpdate annotation — annotations accumulate in stream order, so
 * the last one is the newest. `.find()` here was the bug: it returned the
 * FIRST (oldest) update and froze the Plan card at a stale state.
 */
export function latestTaskUpdate(
  metadata: Record<string, any> | undefined,
  annotations: readonly unknown[] | undefined,
): TaskItem[] {
  const fromMetadata = metadata?.taskUpdate as TaskUpdate | undefined;

  if (fromMetadata?.tasks?.length) {
    return fromMetadata.tasks;
  }

  for (let i = (annotations?.length ?? 0) - 1; i >= 0; i--) {
    const annotation = annotations![i] as TaskUpdate | undefined;

    if (annotation?.type === 'taskUpdate' && Array.isArray(annotation.tasks) && annotation.tasks.length > 0) {
      return annotation.tasks;
    }
  }

  return [];
}
